import { text } from '~/constants';

export const generateWatchlistItemId = (id: number) => `${text.PREFIX.WATCHLIST_ITEM}${id}`;

export const extractWatchlistItemId = (route: string) => parseInt(route.split(text.PREFIX.WATCHLIST_ITEM)[1], 10);
